(() => {
  'use strict';
  if (window.CorlynaRewards) return;

  const defaults = {
    version: '2026-09-08.2', enabled: false, preview: false,
    gift: { id: 48858124124350, productId: 8963254223038, handle: 'hair-removal-cream', title: 'FROHACK Hair Removal Cream', price: 26.99, available: true, ownershipProperty: '_corlyna_gift', ownershipValue: 'hair-removal-cream-v1' },
    variants: {
      '48850413224126': { productId: 8961235353790, units: 1, title: '1 Box Noticeable Enhancement' },
      '48852299317438': { productId: 8961235353790, units: 2, title: '2 Boxes 1 Cup Sizes' },
      '48852299350206': { productId: 8961235353790, units: 3, title: '3 Boxes 2 Cup Sizes' },
      '48860267806910': { productId: 8962102952126, units: 2, title: '2 Boxes - Starter Sculpting Set' },
      '48852293517502': { productId: 8962102952126, units: 1, title: '1Box - Try The CurveSculpt' },
      '48860267839678': { productId: 8962102952126, units: 4, title: '4 Boxes - Complete Curve Care' }
    },
    codes: { shipping: '', gift: { big: '', singles: '', doubles: '', mixed: '', subscriptionMixed: '' } },
    shippingCredit: { code: 'CORLYNA-REWARD-20260908-SHIP-CREDIT', amount: 5.99, currency: 'USD' }
  };
  let supplied = window.CorlynaRewardsConfig || {};
  try { supplied = { ...supplied, ...JSON.parse(document.getElementById('CorlynaRewardsConfig')?.textContent || '{}') }; } catch (_) {}
  const config = { ...defaults, ...supplied, gift: { ...defaults.gift, ...supplied.gift }, variants: { ...defaults.variants, ...supplied.variants }, codes: { ...defaults.codes, ...supplied.codes, gift: { ...defaults.codes.gift, ...supplied.codes?.gift } }, shippingCredit: { ...defaults.shippingCredit, ...supplied.shippingCredit } };
  const rawFetch = window.fetch.bind(window);
  let cooldownUntil = 0;
  const busyMessage = 'Your cart is temporarily busy. Please wait a moment and try again.';
  const savedBusyMessage = 'Your cart changes were saved. The cart is temporarily busy. Please wait, then refresh to confirm your rewards.';
  function cooldownError() {
    const error = new Error(busyMessage);
    error.code = 'CORLYNA_CART_RATE_LIMITED'; error.status = 429; error.retryAt = cooldownUntil;
    return error;
  }
  const isRateLimited = error => error?.code === 'CORLYNA_CART_RATE_LIMITED';
  function checkCooldown() { if (Date.now() < cooldownUntil) throw cooldownError(); }
  function recordRateLimit(response) {
    const value = response.headers.get('retry-after');
    let delay = 30000;
    if (value != null && /^\s*\d+(?:\.\d+)?\s*$/.test(value) && Number.isFinite(Number(value) * 1000)) delay = Number(value) * 1000;
    else if (value && Number.isFinite(Date.parse(value))) delay = Math.max(0, Date.parse(value) - Date.now());
    cooldownUntil = Math.max(cooldownUntil, Date.now() + delay);
    return cooldownError();
  }
  function rateLimitedResponse() {
    const retryAfter = Math.max(0, Math.ceil((cooldownUntil - Date.now()) / 1000));
    return new Response(JSON.stringify({ status: 429, message: busyMessage, description: busyMessage }), {
      status: 429, headers: { 'Content-Type': 'application/json', 'Retry-After': String(retryAfter) }
    });
  }
  const rootPath = String(window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const cartPath = action => rootPath + 'cart' + (action ? '/' + action : '') + '.js';
  const idOf = item => String(item?.variant_id || item?.variantId || item?.merchandiseId || item?.merchandise?.id || item?.id || '').split('/').pop();
  const whole = value => Number.isSafeInteger(Number(value)) && Number(value) > 0 ? Number(value) : 0;
  const codeStrings = values => (Array.isArray(values) ? values : []).map(value => typeof value === 'string' ? value : value?.code).filter(value => typeof value === 'string' && value.trim()).map(value => value.trim());
  const normalizedCode = code => String(code || '').trim().toUpperCase();
  const uniqueCodes = values => [...new Map(values.filter(Boolean).map(code => [normalizedCode(code), code])).values()];
  const ownedCodeNames = () => uniqueCodes([config.codes.shipping, config.shippingCredit?.code, ...Object.values(config.codes.gift || {})].filter(Boolean));
  const isOwnedGift = item => idOf(item) === String(config.gift.id) && (
    item?.properties?.[config.gift.ownershipProperty] === config.gift.ownershipValue ||
    item?.attributes?.some(value => value.key === config.gift.ownershipProperty && value.value === config.gift.ownershipValue)
  );
  const hasPlan = item => Boolean(item?.selling_plan_allocation || item?.selling_plan || item?.sellingPlanId || item?.sellingPlanAllocation);

  function assess(items) {
    let units = 0, singles = 0, doubles = 0, big = 0, lineQuantity = 0, subscriptionOnly = true;
    for (const item of items || []) {
      const variant = config.variants[idOf(item)], quantity = whole(item.quantity);
      if (!variant || !quantity || isOwnedGift(item)) continue;
      const productId = item.product_id || item.productId;
      if (productId != null && String(productId).split('/').pop() !== String(variant.productId)) continue;
      units += whole(variant.units) * quantity;
      lineQuantity += quantity;
      if (String(variant.productId) !== '8961235353790' || variant.units > 2 || !hasPlan(item)) subscriptionOnly = false;
      if (variant.units === 1) singles += quantity;
      else if (variant.units === 2) doubles += quantity;
      else if (variant.units >= 3) big += quantity;
    }
    // Gift bundling is now managed by the merchant's app. Keep existing shipping eligibility.
    return { units, singles, doubles, big, lineQuantity, freeShipping: units >= 2, gift: false, giftCode: '', codes: uniqueCodes(units >= 2 && config.codes.shipping ? [config.codes.shipping] : []) };
  }

  async function json(url, options) {
    checkCooldown();
    const response = await rawFetch(url, { credentials: 'same-origin', ...options });
    if (response.status === 429) throw recordRateLimit(response);
    let value;
    try { value = await response.json(); } catch (_) { throw Error('Your cart connection is temporarily unavailable. Please refresh and try again.'); }
    if (!response.ok) throw Error(typeof value.description === 'string' ? value.description : typeof value.message === 'string' ? value.message : 'Your cart could not be updated. Please try again.');
    return value;
  }
  const post = (action, body) => json(cartPath(action), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
  async function readCart() {
    const cart = await json(cartPath(), { method: 'GET', cache: 'no-store', headers: { Accept: 'application/json' } });
    if (!Array.isArray(cart.items)) throw Error('Your cart could not be read. Please refresh and try again.');
    return cart;
  }
  let lastCart = null, queue = Promise.resolve(), notice = '';
  const serialize = action => {
    const pending = queue.catch(() => {}).then(action);
    queue = pending.catch(() => {});
    return pending;
  };
  function showNotice(message) {
    notice = message || '';
    for (const host of document.querySelectorAll('#cart-errors, #CartDrawer-CartErrors, [data-rewards-error-host]')) {
      let node = host.querySelector('[data-corlyna-rewards-error]');
      if (!notice) { node?.remove(); continue; }
      if (!node) { node = document.createElement('p'); node.dataset.corlynaRewardsError = ''; node.setAttribute('role', 'alert'); host.appendChild(node); }
      node.textContent = notice;
    }
    if (notice) document.dispatchEvent(new CustomEvent('corlyna:rewards-error', { detail: { message: notice } }));
  }
  function publishCart(cart) {
    lastCart = cart;
    document.dispatchEvent(new CustomEvent('corlyna:rewards-cart-updated', { detail: { cart, benefit: assess(cart.items) } }));
    refreshWidgets();
  }
  const currentCodes = cart => uniqueCodes([
    ...codeStrings(cart.discount_codes),
    ...(cart.cart_level_discount_applications || []).filter(application => application.type === 'discount_code').map(application => application.code || application.title).filter(Boolean)
  ]);
  const activeCustomerCodes = cart => {
    const own = new Set(ownedCodeNames().map(normalizedCode));
    return uniqueCodes([
      ...codeStrings((cart.discount_codes || []).filter(code => code && typeof code === 'object' && code.applicable === true)),
      ...(cart.cart_level_discount_applications || []).filter(application => application.type === 'discount_code').map(application => application.code || application.title).filter(Boolean)
    ]).filter(code => !own.has(normalizedCode(code)));
  };
  const sameCodes = (a, b) => a.map(normalizedCode).sort().join('\n') === b.map(normalizedCode).sort().join('\n');

  function verifyGift(cart, benefit) {
    const owned = cart.items.filter(isOwnedGift);
    if (!benefit.gift) {
      if (owned.length) throw Error('Your gift is still updating. Please try again before checkout.');
      return;
    }
    if (owned.length !== 1 || whole(owned[0].quantity) !== 1 || hasPlan(owned[0])) throw Error('Your complimentary gift could not be confirmed. Please try again.');
    const selected = (cart.discount_codes || []).find(code => normalizedCode(typeof code === 'string' ? code : code.code) === normalizedCode(benefit.giftCode));
    if (!selected || selected.applicable === false) throw Error('The complimentary gift discount could not be confirmed. Please try again before checkout.');
    // Shopify can allocate BXGY to a paid line of the same variant. Verify the
    // combined amount, while never removing or changing that paid line.
    const matching = cart.items.filter(item => idOf(item) === String(config.gift.id));
    const original = matching.reduce((sum, item) => sum + Number(item.original_line_price), 0);
    const final = matching.reduce((sum, item) => sum + Number(item.final_line_price), 0);
    const giftPrice = Number(owned[0].original_price);
    if (![original, final, giftPrice].every(Number.isFinite) || giftPrice <= 0 || original - final < giftPrice) throw Error('The complimentary gift price could not be confirmed. Please try again before checkout.');
  }

  async function doReconcile() {
    let cart = await readCart(), changed = false;
    const existingCustomerCodes = activeCustomerCodes(cart);
    if (config.enabled !== true) { publishCart(cart); return { cart, benefit: assess(cart.items), changed }; }
    for (let attempt = 0; attempt < 4; attempt++) {
      const benefit = assess(cart.items);
      if (benefit.freeShipping && !config.codes.shipping || benefit.gift && !benefit.giftCode) throw Error('Bundle rewards are being updated. Please try again before checkout.');
      if (benefit.gift && config.gift.available === false) throw Error('Your complimentary gift is currently unavailable. Please contact us before checkout.');
      const owned = cart.items.filter(isOwnedGift);
      const keeper = benefit.gift ? owned.find(item => !hasPlan(item)) : null;
      const updates = {};
      for (const item of owned) {
        if (!item.key) throw Error('Your gift could not be identified. Please refresh your cart.');
        const quantity = item === keeper ? 1 : 0;
        if (item.quantity !== quantity) updates[item.key] = quantity;
      }
      if (Object.keys(updates).length) { cart = await post('update', { updates }); changed = true; }
      const latestBenefit = assess(cart.items);
      if (JSON.stringify(latestBenefit) !== JSON.stringify(benefit)) { cart = await readCart(); continue; }
      const previous = currentCodes(cart), own = new Set(ownedCodeNames().map(normalizedCode));
      const desired = uniqueCodes([...previous.filter(code => !own.has(normalizedCode(code))), ...benefit.codes]);
      if (!sameCodes(previous, desired)) { cart = await post('update', { discount: desired.join(',') }); changed = true; }
      cart = await readCart();
      if (JSON.stringify(assess(cart.items)) !== JSON.stringify(benefit)) continue;
      const stillActive = new Set(activeCustomerCodes(cart).map(normalizedCode));
      if (existingCustomerCodes.some(code => !stillActive.has(normalizedCode(code)))) throw Error('Your existing discount could not be combined with these rewards. Please review your discount before checkout.');
      verifyGift(cart, benefit);
      publishCart(cart); showNotice('');
      return { cart, benefit, changed };
    }
    throw Error('Your cart is still updating. Please try again before checkout.');
  }
  async function safeReconcile() {
    try { return await doReconcile(); }
    catch (error) {
      if (isRateLimited(error)) throw error;
      // A rewards failure must not leave an automatically added item that could
      // be charged as a normal purchase. Never touch a customer's paid line.
      if (config.enabled === true) {
        try {
          const cart = await readCart(), updates = {};
          cart.items.filter(isOwnedGift).forEach(item => { if (item.key) updates[item.key] = 0; });
          const before = currentCodes(cart), own = new Set(ownedCodeNames().map(normalizedCode));
          const kept = before.filter(code => !own.has(normalizedCode(code)));
          if (Object.keys(updates).length || !sameCodes(before, kept)) {
            const body = { updates };
            if (!sameCodes(before, kept)) body.discount = kept.join(',');
            await post('update', body);
            publishCart(await readCart());
          }
        } catch (cleanupError) {
          if (isRateLimited(cleanupError)) throw cleanupError;
          // Keep checkout blocked until a later retry succeeds.
        }
      }
      throw error;
    }
  }
  function reconcileCart() {
    return serialize(safeReconcile).catch(error => { showNotice(error.message); throw error; });
  }

  async function renderRequest(input, init) {
    let body = init?.body;
    if (body == null && typeof Request !== 'undefined' && input instanceof Request) {
      try {
        const copy = input.clone();
        body = /json/i.test(copy.headers.get('content-type') || '') ? await copy.json() : await copy.formData();
      } catch (_) { body = null; }
    }
    if (typeof body === 'string') { try { body = JSON.parse(body); } catch (_) { body = new URLSearchParams(body); } }
    const get = name => body && typeof body.get === 'function' ? body.get(name) : body?.[name];
    const sections = Array.isArray(get('sections')) ? get('sections') : String(get('sections') || '').split(',');
    const sectionsUrl = new URL(get('sections_url') || location.pathname, location.origin);
    if (sectionsUrl.origin !== location.origin) throw Error('Invalid cart section URL.');
    return { sections: [...new Set(sections.map(value => String(value).trim()).filter(Boolean))], sectionsUrl };
  }
  async function refreshedResponse(response, kind, render, result) {
    let original;
    try { original = await response.clone().json(); } catch (_) { return response; }
    const ids = [...new Set([...render.sections, ...Object.keys(original.sections || {})])];
    let sections = original.sections;
    if (ids.length) {
      try {
        const url = new URL(render.sectionsUrl); url.searchParams.set('sections', ids.join(','));
        const current = await json(url.pathname + url.search, { method: 'GET', cache: 'no-store' });
        if (ids.some(id => typeof current[id] !== 'string')) throw Error('Cart sections unavailable.');
        sections = current;
      } catch (error) { showNotice(isRateLimited(error) ? savedBusyMessage : 'Your cart was updated. Please refresh to see the latest items and rewards.'); }
    }
    // add responses describe only the added line(s); other mutations return a
    // complete cart. Keep that contract and replace stale bundled HTML.
    const body = kind === 'add' ? { ...original } : { ...original, ...result.cart };
    if (sections !== undefined) body.sections = sections;
    const headers = new Headers(response.headers);
    headers.delete('content-length'); headers.delete('content-encoding'); headers.set('content-type', 'application/json');
    return new Response(JSON.stringify(body), { status: response.status, statusText: response.statusText, headers });
  }

  function installFetch() {
    if (window.fetch.corlynaRewardsCart) return;
    async function rewardsFetch(input, init) {
      let url;
      try { url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, location.origin); } catch (_) { return rawFetch(input, init); }
      const method = String(init?.method || (typeof Request !== 'undefined' && input instanceof Request ? input.method : 'GET')).toUpperCase();
      const match = url.origin === location.origin && [rootPath + 'cart/', '/cart/'].some(prefix => url.pathname.startsWith(prefix)) && url.pathname.match(/\/cart\/(add|change|update|clear)(?:\.js)?\/?$/);
      if (!match || method !== 'POST' || config.enabled !== true) return rawFetch(input, init);
      if (Date.now() < cooldownUntil) { showNotice(busyMessage); return rateLimitedResponse(); }
      const rendering = renderRequest(input, init).catch(() => ({ sections: [], sectionsUrl: new URL(location.pathname, location.origin) }));
      return serialize(async () => {
        if (Date.now() < cooldownUntil) { showNotice(busyMessage); return rateLimitedResponse(); }
        const response = await rawFetch(input, init);
        if (response.status === 429) { showNotice(recordRateLimit(response).message); return rateLimitedResponse(); }
        if (!response.ok) return response;
        let result;
        try { result = await safeReconcile(); }
        catch (error) {
          if (isRateLimited(error)) {
            showNotice(savedBusyMessage);
            setTimeout(() => showNotice(notice), 0);
            return response;
          }
          showNotice('Your items were updated, but rewards could not be confirmed. Please try again before checkout.');
          try { const cart = await readCart(); publishCart(cart); result = { cart, benefit: assess(cart.items), changed: false }; }
          catch (_) { return response; }
        }
        const output = await refreshedResponse(response, match[1], await rendering, result);
        setTimeout(() => showNotice(notice), 0);
        return output;
      });
    }
    Object.defineProperty(rewardsFetch, 'corlynaRewardsCart', { value: true });
    window.fetch = rewardsFetch;
  }

  const text = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
  function refreshWidgets() { document.querySelectorAll('corlyna-bundle-rewards').forEach(widget => widget.schedule?.()); }
  class CorlynaBundleRewards extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      try { this.settings = JSON.parse(this.querySelector('[data-rewards-config]')?.textContent || '{}'); } catch (_) { return; }
      const themeRole = String(window.Shopify?.theme?.role || '').toLowerCase();
      const preview = config.preview === true && (window.Shopify?.designMode === true || ['unpublished', 'development'].includes(themeRole));
      if (config.enabled !== true && !preview) return;
      this.initialized = true; this.hidden = false;
      this.scope = this.closest('.main-product__info-container') || this.closest('section') || this.parentElement;
      this.onInput = event => { if (!this.contains(event.target)) { this.schedule(); clearTimeout(this.delay); this.delay = setTimeout(() => this.schedule(), 750); } };
      this.onTierClick = event => {
        const button = event.target.closest('[data-rewards-tier]');
        if (button && this.contains(button) && this.settings.formId) this.selectTier(Number(button.dataset.rewardsTier));
      };
      this.addEventListener('click', this.onTierClick);
      this.onCart = () => this.schedule();
      this.scope.addEventListener('input', this.onInput); this.scope.addEventListener('change', this.onInput);
      document.addEventListener('corlyna:rewards-cart-updated', this.onCart);
      this.observer = new MutationObserver(changes => { if (changes.some(change => !this.contains(change.target))) this.schedule(); });
      this.observer.observe(this.scope, { subtree: true, childList: true, attributes: true, attributeFilter: ['value', 'checked', 'data-corlyna-selected'] });
      this.timer = setInterval(() => { if (!document.hidden) this.schedule(); }, 1000);
      this.querySelectorAll('[data-rewards-preview]').forEach(node => { node.hidden = config.enabled === true; });
      this.render();
    }
    disconnectedCallback() {
      if (!this.initialized) return;
      this.removeEventListener('click', this.onTierClick);
      this.scope.removeEventListener('input', this.onInput); this.scope.removeEventListener('change', this.onInput);
      document.removeEventListener('corlyna:rewards-cart-updated', this.onCart);
      this.observer.disconnect(); clearInterval(this.timer); clearTimeout(this.delay); cancelAnimationFrame(this.frame);
      this.frame = null; this.initialized = false;
    }
    schedule() { if (!this.frame && this.isConnected) this.frame = requestAnimationFrame(() => { this.frame = null; this.render(); }); }
    selectTier(tier) {
      const form = document.getElementById(this.settings.formId);
      if (!form || ![1, 2, 3].includes(tier)) return;
      const choices = Object.entries(config.variants).filter(([, variant]) => String(variant.productId) === String(this.settings.productId)).sort((a, b) => a[1].units - b[1].units);
      const picked = choices.find(([, variant]) => tier === 3 ? variant.units >= 3 : variant.units === tier);
      if (!picked) return;
      const current = String(form.elements.namedItem('id')?.value || '');
      if (picked[0] !== current) {
        const radio = [...this.scope.querySelectorAll('variant-selects input[type="radio"]')].find(input => input.value === picked[1].title);
        if (!radio || radio.disabled) return;
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
      for (const input of [...form.elements].filter(input => input.name === 'quantity' && !input.disabled)) {
        if (input.value !== '1') { input.value = '1'; input.dispatchEvent(new Event('change', { bubbles: true })); }
      }
      this.schedule();
    }
    selection() {
      if (!this.settings.formId) return 0;
      const form = document.getElementById(this.settings.formId), idField = form?.elements?.namedItem('id');
      const id = String(idField?.value || this.settings.selectedVariantId || ''), variant = config.variants[id];
      if (!variant || String(variant.productId) !== String(this.settings.productId)) return 0;
      const fields = form ? [...form.elements].filter(field => field.name === 'quantity' && !field.disabled) : [];
      const quantity = fields.find(field => field.type === 'hidden') || fields.find(field => field.type === 'number') || fields.find(field => whole(field.value));
      return whole(variant.units) * (quantity ? whole(quantity.value) : 1);
    }
    render() {
      const selected = this.selection(), inCart = assess(lastCart?.items || this.settings.cart?.items || []).units;
      const proposed = Boolean(this.settings.formId);
      const total = proposed ? selected : inCart, tier = total >= 3 ? 3 : total >= 2 ? 2 : total === 1 ? 1 : 0;
      this.dataset.boxes = String(total); this.dataset.selectedBoxes = String(selected); this.dataset.cartBoxes = String(inCart);
      this.querySelectorAll('[data-rewards-tier]').forEach(node => {
        const active = Number(node.dataset.rewardsTier) === tier;
        if (active) node.setAttribute('aria-current', 'step'); else node.removeAttribute('aria-current');
        node.disabled = !proposed;
        if (proposed) node.setAttribute('aria-pressed', String(active)); else node.removeAttribute('aria-pressed');
      });
      const available = config.gift.available !== false, gift = this.querySelector('[data-rewards-gift]');
      if (gift) gift.dataset.unlocked = String(total >= 3 && available);
      text(this.querySelector('[data-rewards-gift-badge]'), total >= 3 && available ? 'YOUR FREE GIFT IS UNLOCKED' : 'FREE GIFT WITH 3+ BOXES');
      const remaining = Math.max(0, 3 - total);
      text(this.querySelector('[data-rewards-remaining]'), !available ? 'Gift is currently unavailable.' : total >= 3 ? proposed ? '1 FREE gift with this selection.' : '1 FREE gift with this order.' : `Add ${remaining} more ${remaining === 1 ? 'box' : 'boxes'} to unlock.`);
      let status = proposed ? 'Choose a package to see your rewards.' : 'Add patch products to unlock your rewards.';
      if (tier === 1) status = 'Add 1 more box for FREE shipping.';
      if (tier === 2) status = 'FREE shipping unlocked · Add 1 more box for your FREE gift.';
      if (tier === 3) status = available ? 'FREE shipping + 1 FREE gift unlocked.' : 'FREE shipping unlocked · Gift currently unavailable.';
      text(this.querySelector('[data-rewards-status]'), notice || status);
      text(this.querySelector('[data-rewards-basis]'), total > 0 ? `${total} ${total === 1 ? 'box' : 'boxes'} ${proposed ? 'with this selection' : 'in your cart'}${proposed && inCart > 0 ? ` · Cart rewards include all ${inCart} existing patch ${inCart === 1 ? 'box' : 'boxes'} at checkout` : ''}.` : '');
    }
  }

  function setConfig(patch) {
    if (!patch || typeof patch !== 'object') return config;
    if (patch.gift) Object.assign(config.gift, patch.gift);
    if (patch.shippingCredit) Object.assign(config.shippingCredit, patch.shippingCredit);
    if (patch.variants) Object.assign(config.variants, patch.variants);
    if (patch.codes) { if (patch.codes.gift) Object.assign(config.codes.gift, patch.codes.gift); if ('shipping' in patch.codes) config.codes.shipping = patch.codes.shipping; }
    for (const key of ['enabled', 'preview', 'version']) if (key in patch) config[key] = patch[key];
    return config;
  }
  const api = { config, getConfig: () => config, setConfig, assess, isOwnedGift, isOwnGift: isOwnedGift, codeStrings, ownedCodeNames, readCart, reconcileCart, syncCart: reconcileCart, prepareForCheckout: reconcileCart, refreshWidgets, getLastCart: () => lastCart, getNotice: () => notice };
  window.CorlynaRewards = api;
  api.ready = Promise.resolve(api);
  if (window.__CORLYNA_REWARDS_TEST_NO_INIT) return;
  installFetch();
  if (window.customElements && !customElements.get('corlyna-bundle-rewards')) customElements.define('corlyna-bundle-rewards', CorlynaBundleRewards);
  const init = () => {
    if (config.enabled === true) reconcileCart().then(({ changed }) => {
      // Initial recovery has no original add/change response to render. Ask the
      // theme's own controller to refresh so its YX mount-preservation hooks run.
      if (changed) document.querySelectorAll('cart-items, cart-drawer-items').forEach(controller => {
        if (typeof controller.updateCart === 'function') controller.updateCart();
      });
    }).catch(() => {});
    else readCart().then(publishCart).catch(() => {});
    refreshWidgets();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
